import axios from './axios';

const IngredientsService = {
  getIngredients: async (restaurant_id) => {
    try {
      const response = await axios.get(`/ingredients`)
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  saveIngredients: async (data) => {
    try {
      const response = await axios.post(`/ingredients`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateIngredients: async (id, data) => {
    try {
      const response = await axios.put(`/ingredients/${id}`, data);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  getMenuGroups: async (id) => {
    try {
      const response = await axios.get(`/menu-groups`)
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  },
  updateMenuItem: async (id) => {
    try {
      const response = await axios.put(`/menu-item/${id}/toggle-active`);
      return response.data.data;
    } catch (e) {
      console.error(e);
    }
  }
};

export default IngredientsService;